var React = require('react');

function IconCheckmarkCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"6","cy":"6","r":"6","fill":"white","key":0}),React.createElement("path",{"d":"M6 0C2.68165 0 0 2.68165 0 6C0 9.31086 2.68165 12 6 12C9.31835 12 12 9.31835 12 6C11.9925 2.68165 9.31086 0 6 0ZM8.77154 5.00375L5.78277 7.99251C5.64045 8.13483 5.45318 8.20974 5.25094 8.20974C5.04869 8.20974 4.86142 8.12734 4.7191 7.99251L3.22846 6.49438C2.93633 6.20225 2.93633 5.73034 3.22846 5.4382C3.5206 5.14607 3.99251 5.14607 4.28464 5.4382L5.25094 6.40449L7.70787 3.94008C8 3.64794 8.47191 3.64794 8.76404 3.94008C9.05618 4.23221 9.06367 4.71161 8.77154 5.00375Z","key":1})]);
}

IconCheckmarkCircle.defaultProps = {"viewBox":"0 0 12 12"};

module.exports = IconCheckmarkCircle;

IconCheckmarkCircle.default = IconCheckmarkCircle;
